var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room-footer"},[(_vm.assignToMyself)?_c('footer-reassign',{staticClass:"box-footer chat-input-section p-3 p-lg-4 border-top mb-0 justify-content-center",attrs:{"room":_vm.room}}):_c('footer-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }